export default "/8522fe2631ecefb1e3967be9883671f05392a386/d50cc34e778c6c20c755dccf4a153599.svg";